import React, { useEffect, useState, useRef } from "react";
import Select from 'react-select';
import {getAxiosResponse,postAxiosFormDataResponse,postAxiosResponse} from "../../../services/authApiRoutes/APImethods";
import APIUrls from "../../../services/APIUrls";
import CustomProgressBar from "../../global/CustomProgressBar";
import { transformBlankToNull } from "../../../services/Util";
import axios from "axios";
import { useSelector } from 'react-redux';
import { useForm } from "react-hook-form";
import $ from "jquery";
import {CrossIcon, FileIcon} from "../../../AppIcons";
import Constants from "../../../Constants";


const chunkSize = Constants.CHUNK_SIZE;

export default function DiscussionCreateForm(prop) {
  const workspaceId = prop.id;
  const [notifyUsers, setNotifyUsers] = useState([]);
  const [selectedNotifyUser, setSelectedNotifyUser] = useState({label:"-- Add Recipient --"});
  const [followers,setFollowers] = useState([]);
  const inputRef = useRef(null);
  const [showNotificationUsers, setShowUsers] = useState([]);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [documentFileId, setDocumentFileId] = useState(-1);
  const [hasDocument, setHasDocument] = useState(false);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [showProgress,setShowProgress] = useState(false);
  const [selectedfile, setSelectedFile] = useState("");
  const [currentChunkIndex, setCurrentChunkIndex] = useState(-1);
  const [topicData, setTopicData] = useState({});
  const [charsLeft, setCharsLeft] = useState(3500);
  const { register, handleSubmit ,formState: { errors }} = useForm({mode: "onChange"});
  const owner = useSelector(
    (loginSessionDetail) => loginSessionDetail.loginSession
).value

  const handleNotifyUserChange = (event) => {
    let selectedId = event.value;
    if(event.value === "all"){
      setShowUsers(followers);
      let leftover = notifyUsers.filter(({value})=> (value === "all"));
      setNotifyUsers(leftover);
    }else {
      let result = notifyUsers.find(({ value }) => value == selectedId);
      setShowUsers(current => [...current, result]);
      let rest = notifyUsers.filter(({ value }) => value !== selectedId);
      setNotifyUsers(rest);
    }
    $("#user-error").html("");
  };

  const handleMessageChange = (value)=>{
    setMessage(value);
    setCharsLeft(3500-value.length);
  }

  useEffect(() => {
    fetchMembers();
  }, []);

  const fetchMembers = ()=>{
    getAxiosResponse(APIUrls.CAMPAIGN_MEMBERS(workspaceId))
    .then((response)=>{
      let members = response.data.data;
      let followers = [];
      let data = [{label:"-- Select All Campaign Members-- ",value:"all"}];
      members.forEach((val)=>{
        let user = showNotificationUsers.filter((obj)=> obj.value === val.customerUser.userId);
        if(user.length===0){
          if(val.customerUser.userId !== owner.id){
            data.push({label:getInitials(val.customerUser),value:val.customerUser.userId})
          }
        }
        followers.push({label:getInitials(val.customerUser),value:val.customerUser.userId});
      });
      setFollowers(followers);
      setNotifyUsers(data);
    }).catch((err)=>{
        console.error(err);
    })
};

const getInitials=(user)=>{
    return `${user.firstName} ${user.lastName}(${user.roleSet.displayName})`;
}

  useEffect(()=>{
    //populateNotifyUsers(true,true,true);
  },[followers]);

  useEffect(()=>{
  },[notifyUsers]);

  const removeItem = (user) => {
    setShowUsers((current) =>
      current.filter((showNotificationUsers) => showNotificationUsers.value !== user.value)
    );
    setNotifyUsers((current) => [...current,user]);
    const selectedElement = $(document.activeElement).closest(".multiselect-output");
    if($(document.activeElement).is(':last-child') &&
      selectedElement.children().length > 1){
        selectedElement.find('button:nth-last-child(2)').trigger('focus');
    } else if($(document.activeElement).is(':last-child')){
      $(document.activeElement).closest(".wrap-dropdown").find('.global-dropdown-block input:first-of-type').trigger('focus');
    }
  };

  const fileSelection = (e)=> {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      setTimeout(() => {
        $('#files').trigger('focus')
      }, 500);
    }
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  useEffect(()=>{
    if(currentChunkIndex !== -1){
      readAndUploadCurrentChunk();
    }
  },[currentChunkIndex]);
      
  const readAndUploadCurrentChunk=()=> {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    }else{
      uploadChunk(null);
    }
  };

  const createTopic = ()=>{
    if(showNotificationUsers.length>0){
      let topic = {
        topic:{
          subject:title,
          text: message
        }
      };
      let followers = showNotificationUsers.map((o)=>(o.value));
      if(followers){
        topic.followers = followers;
      }
      if(selectedfile){
        setHasDocument(true);
      }
      topic = transformBlankToNull(topic);
      setTopicData(topic);
      const params = getMetadataParams(topic);
      const urlWithParams = `${APIUrls.CAMPAIGN_TOPIC_METADATA}?${params.toString()}`;
      postAxiosResponse(urlWithParams, params)
      .then((res) => {
        if (res.status === 200) {
          let documentFileId = -1;
          if (res?.data?.data) {
            documentFileId = res?.data?.data;
            setDocumentFileId(documentFileId);
            setCurrentChunkIndex(0);
          }else{
            setShowProgress(true)
            setCurrentChunkIndex(0);
          }
        }
      }).catch((err) => {
        console.error(err);
      });
     
    }else{
      $("#user-error").html("Recipient are required");
      var tmpval = $('#user-error').val();
      if(tmpval == '') {
        $('.cw__input').trigger('focus')
      }
    }
    
  };

  const getMetadataParams=(data)=>{
    const params = new URLSearchParams();
    const topic = data?data.topic:topicData.topic;
    if(topic){
      params.set("topic.subject",topic.subject);
      params.set("topic.text",topic.text);
      showNotificationUsers.forEach(element => {
        params.append("followers",element.value);
      });
    }
    if(selectedfile){
      params.set("name", selectedfile.name);
      params.set("size", selectedfile.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
      params.set("fileDataAttribute","topic.attachment.fileData");
      params.set("topic.attachment.filename",selectedfile.name);
      params.set("topic.attachment.sizeInKilobytes",selectedfile.size);
    }
    params.set("workspaceId", workspaceId);
    params.set("recipientId", "-1");
    params.set("hasDocument", selectedfile?true:false);
    params.set("documentFileId",(documentFileId!==-1)?documentFileId:"");
    return params;
  };

  const uploadChunk=(readerEvent) =>{
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getMetadataParams(null);
    const urlPart = (file ? APIUrls.CAMPAIGN_TOPIC_METADATA_DOCUMENT : APIUrls.CAMPAIGN_TOPIC_METADATA_DOCUMENT.replace("/upload",""))+"?"+params.toString();
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    axios.post(url, data, { headers }).then((response)=>{
      const topicId = response.data?.data?.body?.detail;
      if(selectedfile){
        const filesize = selectedfile.size;
        const chunks = Math.ceil(filesize / chunkSize) - 1;
        const isLastChunk = currentChunkIndex === chunks;
        if (isLastChunk) {
          setCurrentChunkIndex(-1);
          setFileUploadProgress(100);
          setTimeout(() => {
            prop.showDetailsPage(false,topicId);
          }, 1000);
        } else {
          const chunks = Math.ceil(filesize / chunkSize);
          setFileUploadProgress(Math.round((currentChunkIndex / chunks) * 100));
          setCurrentChunkIndex(currentChunkIndex + 1);
        }
      }else{
        setCurrentChunkIndex(-1);
        setTimeout(() => {
          prop.showDetailsPage(false,topicId);
        }, 1000);
      }
    });
  };

  const reset = () =>{
    prop.toggleTopicList(false);
  };

  const validations = {
    title:{
      required:"Title is required",
      maxLength: {
        value: 250,
        message: "Title must be 250 characters long"
      },
      pattern: {
        value: /^[a-z\d\-_'\s]+$/i,
        message: "Please Enter the Valid title"
      }
    },
    message:{
      required:"Message is required",
      maxLength: {
        value: 3500,
        message: "Message must be 3500 characters long"
      }
    }
  };

  useEffect(()=>{
    $('.firstFocus .cw__input').trigger('focus');
   },[]);

   $(document).ready(function(){
    $(".cw__input").attr({
      "aria-describedby":"user-error",  
      'aria-required':'true'
    });
   });
  
  return (
    <>
      <div className="campaign_details-task-create-form discussion-form">
        <div className="projects-heading">
          <h5>New Discussion</h5>
        </div>
        <form onSubmit={handleSubmit(createTopic)}>
          <div className="task-form-content">
              <div className="form-group">
                <div className="flex wrap-dropdown">
                  <div className="global-dropdown-block flex-center firstFocus">
                    <label>To</label>
                    <Select className="global-dropdown-select" classNamePrefix='cw'
                      name="selectedUsers"
                      defaultValue={notifyUsers[0]}
                      aria-label="To"
                      options={notifyUsers}
                      value={selectedNotifyUser}
                      onChange={e => handleNotifyUserChange(e)}
                    />
                    <div id="user-error" className="error textDanger m-0">
                      {errors.selectedUsers?.message}
                    </div>
                    <div className="multiselect-output flex">
                      {showNotificationUsers.map((user,index) => {
                        return (
                                <button key={index} aria-label={"remove " + user.label}>

                                  <strong>
                                    {user.label}
                                  </strong>
                                  <span onClick={(e) => { e.preventDefault(); removeItem(user); }}>{CrossIcon}</span>
                                </button>
                            );
                          })}
                    </div>
                  </div>
                </div>
              </div>
              <div className="form-group title">
                <p>Who will have access to this discussion? <span>Your internal company users</span></p>
              </div>
              <div className="form-group">
                <div className="form-text">
                  <label htmlFor="title">Title:</label><br />
                  <input type="text" className="form-control-sm" id="title" name="title" aria-required='true'
                   aria-describedby="errorTitle"
                    {...register("title",validations.title)}
                    onChange={(event) => setTitle(event.target.value)}/>
                  <div className="error textDanger m-0" id="errorTitle">
                    {errors.title?.message}
                  </div>
                </div>
              </div>
              <div className="form-group text">
                <div className="form-text">
                  <label htmlFor="message">Message </label>
                  <textarea id="message" className="textarea" aria-required='true' placeholder="3500 characters limit" maxLength={3500}
                  {...register("message",validations.message)}
                    onChange={(event) => handleMessageChange(event.target.value)} aria-describedby="errorMessage"></textarea>
                  <div>{charsLeft} chars left</div>
                  <div className="error textDanger m-0" id="errorMessage">
                    {errors.message?.message}
                  </div>
                </div>
              </div>
              <div className="flex wrap-dropdown file-btn">
                <div className="file-input flex w-d100">
                  <div className="input-file mar-bot16">
                    <input type="file" id="files" onChange={fileSelection} />
                     <label  className="file-button flex-center" htmlFor="files" aria-label={!selectedfile ? "Choose file" : "Select a different file"}>
                            {!selectedfile ? "Choose file" : "Select a different file"}
                    </label>
                  </div>
                  <div className={selectedfile? "uploading-files-block uploading-success w-d100": "uploading-files-block uploading-success w-d100 hide"}>
                      <div className="uploading-file-list flex">
                        <div className="left-file-desc flex-center">
                          <div className="icon-block">
                            {FileIcon}
                          </div>
                          <div className="file-text">
                            <span className="ext-name">{selectedfile?.name}</span>
                            <strong>
                              <span className="date-name">01/09/2022</span>
                              <span className="file-size">
                                {formatBytes(selectedfile?.size)}
                              </span>
                              </strong>
                          </div>
                        </div>
                      </div>
                      <div className={showProgress ? "right-progressbar" : "right-progressbar hide"}>
                        <CustomProgressBar
                          completed={fileUploadProgress}
                          labelLineHeight="1px"
                          labelSize="14px"
                          width="100%"
                          labelClassName="progressBarLabel"
                          borderRadius = "30px"
                          labelAlignment="outside"
                          labelColor="rgba(0,0,0,0.87)"
                          height="10px"
                          className="file_upload_progress"
                          bgColor="#06B878"
                          baseBgColor="#D1DEF0"
                          ariaValuetext={fileUploadProgress}
                          aria-label=""
                          aria-valuenow={fileUploadProgress}/>
                      </div>
                  </div>
                </div>
              </div>
          </div>
          <div className="flex two-col justify-end">
            <button className={(title === "" && message === "") ? "btn btn-bold disabled-btn": "btn btn-bold"}
              type="submit">Submit</button>
            <button className="blue-btn" onClick={reset}>Cancel</button>
          </div>
        </form>
      </div>
    </>);
};
